// extracted by mini-css-extract-plugin
export default {"lds_ring":"spinner_lds_ring__ScUNQ"};